import videojs from 'video.js';

class PromoCodeTimer extends videojs.getComponent('Component') {
  constructor(player, options) {
    super(player, options);
    this.isCountdownExpired = false;
    if (player.paused()) {
      player.one('play', () => {
        this.init(options);
      });
    } else {
      this.init(options);
    }
  }

  init(options) {
    let duration = options.duration * 60;
    let intervalId = setInterval(() => {
      if (duration <= 0) {
        clearInterval(intervalId);
        this.isCountdownExpired = true;
        this.el().textContent = 'Промокод';
      } else {
        this.el().textContent = this.getCountdown(duration--);
      }
    }, 1000);
  }

  createEl() {
    return videojs.dom.createEl('span', {className: 'vjs-promo-code__timer'});
  }

  getCountdown(duration) {
    let result = '';
    let hour = Math.floor(duration / 3600);
    if (hour >= 1) {
      result += `${hour}:`;
      duration = duration - hour * 3600;
    }
    let min = `0${Math.floor(duration / 60)}`.slice(-2);
    let sec = `0${duration - min * 60}`.slice(-2);
    result += `${min}:${sec}`;
    return result;
  }
}

videojs.registerComponent('PromoCodeTimer', PromoCodeTimer);

